import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { useMemo } from 'react'

import { CMMS_RECORD_TYPES } from './cmmsRecordTypes'
import { isCmmsRecordId, parseWorkOrders } from './workOrder'

export function useWorkOrders(ids: string[]) {
  const { siteID, orgID } = useKnowledgeDocumentDataContext()
  const filteredIds = ids.filter(isCmmsRecordId)
  const result = useGetRolodexEntriesByLoadOptions<unknown>(
    filteredIds.length
      ? {
          ids: filteredIds,
          type: [...CMMS_RECORD_TYPES],
          tags: { site: siteID, organization: orgID },
          limit: filteredIds.length,
        }
      : undefined
  )
  const entries = useMemo(
    () => parseWorkOrders(result.data, siteID, orgID),
    [result.data, siteID, orgID]
  )
  return {
    entries,
    isLoading: result.isLoading,
    error: result.error,
    retry: result.mutate,
  }
}

export function useWorkOrder(id?: string) {
  const result = useWorkOrders(id ? [id] : [])
  return { ...result, entry: result.entries.find((entry) => entry.id === id) }
}
